var _desc, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPosition5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "10 by 10 orthogonal maze") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "10 by 10 orthogonal maze generated by The Maze Generator Website (https://www.mazegenerator.net/).")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 2,
    x2: 81.372,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 2,
    x2: 162,
    y2: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.251 17.999 L 98 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 18,
    x2: 146,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 34,
    x2: 130,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146,
    y1: 34,
    x2: 162,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.024,
    y1: 66.031,
    x2: 50,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 50,
    x2: 146,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 66,
    x2: 114,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 66,
    x2: 162,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.856,
    y1: 81.972,
    x2: 66,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 82,
    x2: 98,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 82,
    x2: 146,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 98,
    x2: 82,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 98,
    x2: 114,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 98,
    x2: 146,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.934,
    y1: 113.94,
    x2: 34.027,
    y2: 114.008
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 114,
    x2: 98,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 130,
    x2: 82,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 130,
    x2: 162,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 146,
    x2: 66,
    y2: 146
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 146,
    x2: 146,
    y2: 146
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 162,
    x2: 82,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.274,
    y1: 162.065,
    x2: 162,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 2,
    x2: 2.226,
    y2: 145.068
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 2,
    x2: 18,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 50,
    x2: 18,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.096,
    y1: 97.669,
    x2: 18,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.957,
    y1: 130.903,
    x2: 17.881,
    y2: 145.002
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 18,
    x2: 34,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 82,
    x2: 34,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 114,
    x2: 34,
    y2: 146
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.931,
    y1: 18.04,
    x2: 50,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 82,
    x2: 49.919,
    y2: 129.867
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 18,
    x2: 66,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 66,
    x2: 82,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 98,
    x2: 82,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 130,
    x2: 82,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 82,
    x2: 98,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 114,
    x2: 98,
    y2: 146
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 113.971 17.972 C 113.971 23.838 114.023 40.713 114.023 30.847"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 66,
    x2: 114,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 98,
    x2: 114,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 34,
    x2: 130,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 114,
    x2: 130,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146,
    y1: 82,
    x2: 146,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.517,
    y1: 17.603,
    x2: 162,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.217,
    y1: 114.135,
    x2: 18,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.353,
    y1: 145.094,
    x2: 17.881,
    y2: 145.002
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 82,
    x2: 18.107,
    y2: 81.925
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.85,
    y1: 34.067,
    x2: 18,
    y2: 34
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.03019, 0, 0, 0.028854, -0.346778, 143.257126)",
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M 1415.733 -4719.216 C 1432.249 -4717.878 1446.556 -4730.149 1447.893 -4746.608 C 1449.172 -4763.066 1436.901 -4777.372 1420.385 -4778.768 C 1404.043 -4779.989 1389.621 -4767.718 1388.399 -4751.26 C 1387.003 -4734.918 1399.274 -4720.496 1415.732 -4719.216"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M 1390.433 -4706.946 C 1396.307 -4711.075 1403.46 -4713.808 1411.427 -4713.11 C 1421.663 -4712.296 1430.037 -4705.957 1435.155 -4698.222 L 1465.28 -4638.496 L 1506.396 -4610.174 C 1509.885 -4607.499 1512.095 -4603.138 1511.63 -4598.368 C 1511.048 -4590.983 1504.593 -4585.457 1497.207 -4586.097 C 1494.939 -4586.214 1493.078 -4587.144 1491.042 -4588.075 L 1446.204 -4618.956 C 1444.809 -4620.061 1443.704 -4621.456 1442.773 -4622.91 L 1431.549 -4645.3 L 1417.999 -4585.748 L 1470.979 -4523.172 C 1472.2 -4521.253 1473.015 -4518.985 1473.48 -4516.717 L 1487.786 -4441.172 C 1487.67 -4439.486 1487.902 -4438.439 1487.786 -4437.101 C 1486.972 -4425.819 1477.202 -4417.677 1466.094 -4418.491 C 1456.847 -4419.247 1450.043 -4426.051 1447.891 -4434.484 L 1434.399 -4505.26 L 1391.305 -4552.366 L 1381.36 -4506.481 C 1381.011 -4504.329 1378.162 -4499.793 1377.347 -4497.99 L 1335.998 -4428.319 C 1331.927 -4421.98 1325.006 -4417.909 1317.156 -4418.549 C 1305.932 -4419.363 1297.616 -4429.133 1298.546 -4440.299 C 1298.779 -4443.44 1300.117 -4446.754 1301.28 -4449.023 L 1339.663 -4513.402 L 1371.707 -4655.302 L 1350.771 -4638.379 L 1339.663 -4587.841 C 1338.151 -4581.327 1332.277 -4576.035 1325.357 -4576.559 C 1317.855 -4577.14 1312.388 -4583.595 1312.97 -4591.098 C 1312.97 -4591.679 1313.086 -4592.261 1313.202 -4592.959 L 1326.345 -4651.871 C 1327.159 -4654.371 1328.497 -4656.639 1330.474 -4658.384 L 1390.433 -4706.944 L 1390.433 -4706.946 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition5);
export default __webpack_public_path__ + "static/media/Position5.a337b6a09c1aa4526337d0f8825a90d9.svg";
export { ForwardRef as ReactComponent };